import {DEFAULT_VALUES, HardshipAmountType, PaymentPlanBuilderFrequency, PlanType} from "./utils";
import {IPlanMatrix} from "../../../../../../../declerations/server/payment_plan_models";
import {divide} from "lodash";

type PlanBuilder = {
  frequency: PaymentPlanBuilderFrequency;
  planType?: PlanType;
  downPayment?: number;
  numberOfHardshipInstallments?: number;
  hardshipAmount?: HardshipAmountType;
  hardshipCustomAmount?: number;
};
const getHardshipDetails = (selectedPlan: IPlanMatrix) => {
  if (selectedPlan.plan_type === PlanType.MATRIX_DOWN_PAYMENT) {
    return {
      downPayment: divide(selectedPlan.first_plan_details.installment_size, 100),
      numberOfHardshipInstallments: selectedPlan.first_plan_details.number_of_installments,
      hardshipAmount: undefined,
      hardshipCustomAmount: undefined,
    };
  }
  if (selectedPlan.plan_type === PlanType.MATRIX_HARDSHIP) {
    const isCustomAmount = ![2500, 5000, 7500].includes(selectedPlan.first_plan_details.installment_size);
    return {
      downPayment: undefined,
      numberOfHardshipInstallments: selectedPlan.first_plan_details.number_of_installments,
      hardshipAmount: isCustomAmount ? "custom" : divide(selectedPlan.first_plan_details.installment_size, 100),
      hardshipCustomAmount: isCustomAmount ? divide(selectedPlan.first_plan_details.installment_size, 100) : undefined,
    };
  }
  return {};
};

export const getDefaultValues = (totalBalance: number, selectedPlan: IPlanMatrix | null): PlanBuilder => {
  if (selectedPlan) {
    const {downPayment, numberOfHardshipInstallments, hardshipAmount, hardshipCustomAmount} =
      getHardshipDetails(selectedPlan);
    return {
      frequency: selectedPlan.installment_frequency,
      planType: selectedPlan.plan_type,
      downPayment,
      numberOfHardshipInstallments,
      hardshipAmount: hardshipAmount as HardshipAmountType,
      hardshipCustomAmount,
    };
  }
  return {
    frequency: "monthly",
    planType: undefined,
    downPayment: DEFAULT_VALUES.downPaymentInstallment,
    numberOfHardshipInstallments: DEFAULT_VALUES.numberOfHardshipInstallments,
    hardshipAmount: DEFAULT_VALUES.hardshipInstallment as HardshipAmountType,
    hardshipCustomAmount: undefined,
  };
};
